function assert(condition, message) {
  if (!condition)
    throw new Error(message);
}
const isServer = typeof window === "undefined";
const isClient = typeof window !== "undefined";
const MILLISECONDS_IN_MINUTE = 6e4;
const MINUTES_IN_YEAR = 525960;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  const number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
const isPast = (date) => {
  return date.getTime() < Date.now();
};
function differenceInMilliseconds(dateLeft, dateRight) {
  return dateLeft.getTime() - dateRight.getTime();
}
function differenceInMinutes(dateLeft, dateRight) {
  const diff = differenceInMilliseconds(dateLeft, dateRight) / MILLISECONDS_IN_MINUTE;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}
function addMilliseconds(date, amount) {
  const timestamp = date.getTime();
  const cleanAmount = toInteger(amount);
  return new Date(timestamp + cleanAmount);
}
function addMinutes(date, amount) {
  const cleanAmount = toInteger(amount);
  return addMilliseconds(date, cleanAmount * MILLISECONDS_IN_MINUTE);
}
function addYears(date, amount) {
  const cleanAmount = toInteger(amount);
  return addMinutes(date, cleanAmount * MINUTES_IN_YEAR);
}
function readCookie(name) {
  if (typeof document === "undefined")
    return null;
  const cookie = document.cookie;
  const setPos = cookie.search(new RegExp("\\b" + name + "="));
  const stopPos = cookie.indexOf(";", setPos);
  let res;
  if (!~setPos)
    return null;
  res = decodeURIComponent(
    cookie.substring(setPos, ~stopPos ? stopPos : void 0).split("=")[1] || ""
  );
  return res.charAt(0) === "{" ? JSON.parse(res) : res;
}
const setCookie = (name, value, expires) => {
  const result = `${name}=${value};path=/;expires=${expires}`;
  document.cookie = result;
};
const deleteCookie = (name) => setCookie(name, "", "Thu, 01 Jan 1970 00:00:01 GMT");
function compose(middleware) {
  if (!Array.isArray(middleware)) {
    throw new TypeError("Middleware stack must be an array!");
  }
  for (const handler of middleware) {
    if (typeof handler !== "function") {
      throw new TypeError("Middleware must be composed of functions!");
    }
  }
  return function(req, res, next) {
    let index = -1;
    function dispatch(i, error) {
      if (error) {
        return Promise.reject(error);
      }
      if (i <= index)
        throw new Error("next() called multiple times");
      index = i;
      let handler = middleware[i];
      if (!handler) {
        return Promise.resolve();
      }
      try {
        return Promise.resolve(handler(req, res, dispatch.bind(null, i + 1)));
      } catch (err) {
        return Promise.reject(err);
      }
    }
    return dispatch(0).then(next);
  };
}
function round(num, decimalPlaces) {
  const p = Math.pow(10, decimalPlaces);
  const m = num * p * (1 + Number.EPSILON);
  return Math.round(m) / p;
}
function prettyMs(ms) {
  if (Math.abs(ms) >= 1e3) {
    return `${round(ms / 1e3, 1)}s`;
  }
  return `${ms}ms`;
}
function interopDefault(mod) {
  return mod.default || mod;
}
function truncateString(str, maxLength) {
  return str.length > maxLength ? str.substring(0, maxLength - 3) + "..." : str;
}

export { assert as a, isServer as b, isPast as c, differenceInMilliseconds as d, differenceInMinutes as e, addMilliseconds as f, addMinutes as g, addYears as h, isClient as i, deleteCookie as j, compose as k, interopDefault as l, prettyMs as p, readCookie as r, setCookie as s, truncateString as t };
